export var generateVideoPath = function (video) {
    return video ? "Video/" + video.code : undefined;
};
